.notification {
  padding-left: var(--rc-theme-spacing-ms);
  background-color: var(--rc-theme-color-surface-default);
  cursor: pointer;
}

.notification:hover {
  background-color: var(--rc-theme-color-surface-subtle);
}

.unread {
  margin: 1px 0;
  background: var(--rc-theme-color-primary-default10);
}

.unread:hover {
  background-color: var(--rc-theme-color-primary-default6);
}

.content {
  padding: var(--rc-theme-spacing-xs) 0;
  border-bottom: var(--rc-theme-border-base);
}

.icon {
  --notification-icon-size: 36px;

  flex-shrink: 0;
  width: var(--notification-icon-size);
  height: var(--notification-icon-size);
  border-radius: 50%;
}
